import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-data-to-be-updated",
    templateUrl: "./data-to-be-updated.component.html",
    styleUrls: ["./data-to-be-updated.component.scss"]
})
export class DataToBeUpdatedComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

}
